import { Link } from "react-router-dom";
import { blogCategories as defaultCategories } from "../../data/blogContent";
import { resolveArticleCover } from "../../utils/articleCoverImage";

const ArticleCard = ({
  article,
  className = "",
  basePath = "/blog",
  categories = defaultCategories,
  readArticleLabel = "Leer artículo completo",
}) => {
  const category = categories[article.category];
  const cover = resolveArticleCover(article, categories);

  if (!category) {
    return null;
  }

  return (
    <article
      className={`flex flex-col bg-white rounded-2xl shadow-md hover:shadow-[0_26px_46px_rgba(15,26,73,0.22)] hover:-translate-y-1.5 transition-all duration-300 overflow-hidden border border-blue-50/50 ${className}`}
    >
      <div
        className="h-44 sm:h-48 bg-cover bg-center rounded-t-3xl"
        style={{ backgroundImage: `url(${cover.src})` }}
        role="img"
        aria-label={cover.alt}
      />
      <div className="flex flex-col flex-1 p-5 sm:p-6 gap-3 sm:gap-4">
        <div className="flex flex-wrap items-center gap-2 sm:gap-3 text-xs sm:text-sm font-semibold text-blue-700 uppercase tracking-wide">
          <span className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-[0.65rem] sm:text-xs">
            {category.title}
          </span>
          <span className="text-gray-400">{article.date}</span>
        </div>
        <h3 className="text-xl sm:text-2xl font-bold text-[#123070] leading-tight">
          {article.title}
        </h3>
        <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="mt-auto flex flex-wrap justify-between gap-2 items-center text-xs sm:text-sm text-gray-500">
          <span className="font-medium">{article.author}</span>
          <span>{article.readTime}</span>
        </div>
        <Link
          to={`${basePath}/${article.category}/${article.slug}`}
          className="inline-flex items-center gap-2 mt-4 text-sm sm:text-base text-blue-700 font-semibold hover:text-blue-900 transition-colors duration-150"
        >
          {readArticleLabel}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </Link>
      </div>
    </article>
  );
};

export default ArticleCard;
